module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-edit container"
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('header-back')], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-md-5"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Edit Page #" + _vm._s(_vm.key))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "form-create"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pageTitle"
    }
  }, [_vm._v("Title:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pageTitle"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('slug-field', {
    attrs: {
      "string-to-slug": _vm.stringToSlug
    },
    on: {
      "update": _vm.updatePageSlug
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pageCSSClass"
    }
  }, [_vm._v("CSS Class")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.css_class),
      expression: "currentPage.css_class"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pageCSSClass"
    },
    domProps: {
      "value": (_vm.currentPage.css_class)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPage, "css_class", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage.listed),
      expression: "currentPage.listed"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pagePosition"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.position),
      expression: "currentPage.position"
    }],
    attrs: {
      "type": "text",
      "id": "pagePosition"
    },
    domProps: {
      "value": (_vm.currentPage.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPage, "position", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.published),
      expression: "currentPage.published"
    }],
    attrs: {
      "type": "checkbox",
      "id": "pagePublished"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentPage.published) ? _vm._i(_vm.currentPage.published, null) > -1 : (_vm.currentPage.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentPage.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentPage.published = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentPage.published = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentPage, "published", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pagePublished"
    }
  }, [_vm._v("Published")]), _vm._v(" | \n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.locked),
      expression: "currentPage.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "pageLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentPage.locked) ? _vm._i(_vm.currentPage.locked, null) > -1 : (_vm.currentPage.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentPage.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentPage.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentPage.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentPage, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pageLocked"
    }
  }, [_vm._v("Locked")]), _vm._v(" | \n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.listed),
      expression: "currentPage.listed"
    }],
    attrs: {
      "type": "checkbox",
      "id": "pageListed"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentPage.listed) ? _vm._i(_vm.currentPage.listed, null) > -1 : (_vm.currentPage.listed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentPage.listed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentPage.listed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentPage.listed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentPage, "listed", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pageListed"
    }
  }, [_vm._v("Listed")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group dates"
  }, [_c('p', [_c('strong', [_vm._v("Created:")]), _vm._v(" " + _vm._s(_vm._f("timestampToDate")(_vm.currentPage.created))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Last update:")]), _vm._v("  " + _vm._s(_vm._f("timestampToDate")(_vm.currentPage.updated)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "/ Edit"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        path: '/work/' + _vm.currentPage.slug
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Preview")])], 1)], 1)])]), _vm._v(" "), _c('file-manager', {
    attrs: {
      "page-key": _vm.key
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-md-7"
  }, [_c('slice-manager', {
    attrs: {
      "page-key": _vm.key
    },
    on: {
      "update": _vm.updatePageData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b554c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back/page-edit/PageEdit.vue
// module id = 254
// module chunks = 1